import providerService from '../provider/ProviderService'
import ApiService from '../ApiService'
import axios from 'axios';

const importationsService = {
  async getProviders() {
    const data = await providerService.getProviders()
    return data.data
  },
  getImportations(idProvider) {
    // return ApiService.get(`importations/${idProvider}`)
    return axios.get(`http://104.248.183.112:3001/importations/${idProvider}`)
  },
  updateImportations(file, id) {
    // return ApiService.postFile(`/importations/update/${id}`, file)
    const formData = new FormData();
    const headers = { 'Content-Type': 'multipart/form-data' };
    formData.append("attachment", file);
    return axios.post(`http://104.248.183.112:3001/importations/update/${id}`, formData, { headers })
  }
}

export default importationsService
